import { UserResources } from "src/app/models/user-resources.model";
import { ReduxWrapperLazy } from "../app.state";

export class UserResourcesState {
	m365UserId: string;
	userResources: UserResourcesStructure;
}
export class UserResourcesStructure {
	sites!: ReduxWrapperLazy<UserResources>
	hubsites!: ReduxWrapperLazy<UserResources>
	teams!: ReduxWrapperLazy<UserResources>
	planners!: ReduxWrapperLazy<UserResources>
	projects!: ReduxWrapperLazy<UserResources>
	documentLibraries!: ReduxWrapperLazy<UserResources>
}

export const resourceTypeDefaultValue: ReduxWrapperLazy<UserResources> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	lazyLoading: false,
	value: { skipToken: "", resources: [], total: "", loadedFrom: undefined },
};

export const resourceStructureDefaultValue: UserResourcesStructure = {
	sites: { ...resourceTypeDefaultValue },
	hubsites: { ...resourceTypeDefaultValue },
	teams: { ...resourceTypeDefaultValue },
	planners: { ...resourceTypeDefaultValue },
	projects: { ...resourceTypeDefaultValue },
	documentLibraries: { ...resourceTypeDefaultValue }
};

export const userResourcesInitialState: UserResourcesState[] = [];
